var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row pb-16 pt-16"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('strong',[_vm._v(_vm._s(_vm.label))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }